module.exports = __webpack_public_path__ + "img/gongan.d0289dc0.jpg";